import { Box, makeStyles } from "@material-ui/core";
import * as React from "react";

import theme from "@/theme";

import { FormErrorText } from "../FormErrorText";

const useStyles = makeStyles(() => ({
  row: {
    width: "100%",
    border: 0,
    borderBottom: `1px solid ${theme.palette.semantic["border/default"]}`,
    padding: "16px 0",
    background: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 8,
    cursor: "pointer",
    textAlign: "left",
    font: "inherit",
    fontSize: 14,
    color: theme.palette.text.primary,
    "&:focus-visible": { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: 2 },
  },
  label: { flex: 1 },
  value: { display: "flex", alignItems: "center", gap: 8, maxWidth: "60%", overflowWrap: "anywhere" },
  empty: { color: theme.palette.text.secondary },
  error: { color: theme.palette.semantic["text/error"] },
  errorSurface: { backgroundColor: theme.palette.semantic["status/error-bg"], borderRadius: 8, padding: "0 12px" },
  optional: { fontSize: 10, color: theme.palette.text.secondary, marginLeft: 8 },
  disabled: { cursor: "default", color: theme.palette.text.disabled },
  chevron: {
    width: 6,
    height: 10,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    "& img": { display: "block" },
  },
}));

export const FormRow = React.forwardRef<
  HTMLButtonElement,
  {
    label: string;
    value?: string;
    error?: string;
    onClick: () => void;
    onBlur?: () => void;
    placeholder?: string;
    optional?: boolean;
    disabled?: boolean;
    errorSurface?: boolean;
  }
>(
  (
    {
      label,
      value,
      error,
      onClick,
      onBlur,
      placeholder = "未選択",
      optional = false,
      disabled = false,
      errorSurface = false,
    },
    ref
  ) => {
    const classes = useStyles();
    const errorId = `row-${label}-error`;
    return (
      <Box className={error && errorSurface ? classes.errorSurface : undefined}>
        <button
          ref={ref}
          type="button"
          className={`${classes.row} ${disabled ? classes.disabled : ""}`}
          disabled={disabled}
          onClick={onClick}
          onBlur={onBlur}
          aria-invalid={!!error}
          aria-describedby={error ? errorId : undefined}
          aria-haspopup="dialog"
        >
          <span className={classes.label}>
            {label}
            {optional && <span className={classes.optional}>任意</span>}
          </span>
          <span className={`${classes.value} ${!value ? classes.empty : ""} ${error ? classes.error : ""}`}>
            <span>{value || placeholder}</span>
            <span className={classes.chevron} aria-hidden="true">
              <img src="/icons/ds-v2-field-chevron.svg" alt="" />
            </span>
          </span>
        </button>
        {error && <FormErrorText id={errorId}>{error}</FormErrorText>}
      </Box>
    );
  }
);

FormRow.displayName = "FormRow";
